if (!customElements.get('welcome-offer')) {
  customElements.define('welcome-offer', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.storageKey = `irare_welcome_seen_${this.dataset.campaign}`;
      this.seen = false;
      this.ready = false;
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-welcome-close], [data-welcome-claim]')) {
          this.hidden = true;
          this.remember();
        }
      }, options);
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.hidden) {
          this.hidden = true;
          this.remember();
        }
      }, options);
      document.addEventListener('visitorConsentCollected', () => {
        if (!this.storageAllowed()) {
          try { localStorage.removeItem(this.storageKey); } catch (_) { /* Storage may be blocked. */ }
        } else if (this.seen) {
          this.remember();
        }
        this.tryShow();
      }, options);
      document.addEventListener('visibilitychange', () => this.tryShow(), options);
      const start = () => {
        this.timer = setTimeout(() => {
          this.ready = true;
          this.tryShow();
        }, Number(this.dataset.delay) || 0);
        if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
          window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {
            if (this.isConnected) this.tryShow();
          });
        }
      };
      if (document.readyState === 'complete') start();
      else window.addEventListener('load', start, { ...options, once: true });
    }

    storageAllowed() {
      return window.Shopify?.customerPrivacy?.preferencesProcessingAllowed() === true;
    }

    remember() {
      if (!this.storageAllowed()) return;
      try {
        localStorage.setItem(this.storageKey, String(Date.now() + Number(this.dataset.days) * 86400000));
      } catch (_) { /* The offer remains usable when storage is unavailable. */ }
    }

    tryShow() {
      if (!this.ready || this.seen || document.hidden) return;
      // Keep Shopify's consent request ahead of the promotional notification.
      if (window.Shopify?.customerPrivacy?.shouldShowBanner()) return;
      if (this.storageAllowed()) {
        try {
          if (Number(localStorage.getItem(this.storageKey)) > Date.now()) return;
        } catch (_) { /* Continue without remembering this visit. */ }
      }
      this.seen = true;
      this.hidden = false;
      this.remember();
      // Announce without moving focus away from the shopper's task.
      const announcement = document.createElement('span');
      announcement.className = 'visually-hidden';
      announcement.setAttribute('role', 'status');
      this.append(announcement);
      this.announcementTimer = setTimeout(() => {
        announcement.textContent = 'Welcome to iRARE. Get 15% off your first order. Welcome offer available.';
      }, 100);
    }

    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
      clearTimeout(this.announcementTimer);
    }
  });
}
